module.exports = __webpack_public_path__ + "img/icon_web04_culture2@2x.cb1720df.png";